import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dropdown"
export default class extends Controller {
  static targets = ["menu"]
  static values = { open: Boolean }

  toggle(event) {
    event.stopPropagation()

    if (this.openValue) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    // Close all other dropdowns first
    this.closeOtherDropdowns()

    this.menuTarget.classList.remove("hidden")
    this.openValue = true
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.openValue = false
  }

  closeOtherDropdowns() {
    // Find all dropdown controllers and close them
    document.querySelectorAll('[data-controller="dropdown"]').forEach((element) => {
      if (element !== this.element) {
        const menu = element.querySelector('[data-dropdown-target="menu"]')
        if (menu) {
          menu.classList.add("hidden")
        }
      }
    })
  }

  closeOnClickOutside(event) {
    if (!this.element.contains(event.target) && this.openValue) {
      this.close()
    }
  }

  closeOnEscape(event) {
    if (event.key === "Escape" && this.openValue) {
      this.close()
    }
  }

  connect() {
    this.closeOnClickOutside = this.closeOnClickOutside.bind(this)
    this.closeOnEscape = this.closeOnEscape.bind(this)

    document.addEventListener("click", this.closeOnClickOutside)
    document.addEventListener("keydown", this.closeOnEscape)
  }

  disconnect() {
    document.removeEventListener("click", this.closeOnClickOutside)
    document.removeEventListener("keydown", this.closeOnEscape)
  }
}
